export enum GameState {
    IN_GAME='IN_GAME',
    WAIT_GAME='WAIT_GAME',
    FINISH_GAME='FINISH_GAME',
}
